import { envHelper } from "../utils/envHelper";
import { appendFileExtension, hasExtension } from "../utils/path";

class BlobAudioLoader {
  key = "blobaudio";

  async load(assetsPath) {
    const allowedExtension = envHelper.getAudioSupportedExtension();
    const url = hasExtension(assetsPath)
      ? assetsPath
      : appendFileExtension(assetsPath, allowedExtension);

    const response = await fetch(url);

    if (!response.ok) {
      console.warn(`[AssetLoader] Failed to load audio: ${response.statusText} (${url})`);
      return this._createFallback();
    }

    const blob = await response.blob();

    // Check if we received HTML instead of audio (404 page)
    if (blob.type.startsWith('text/html')) {
      console.warn(`[AssetLoader] Audio file not found: ${url}`);
      return this._createFallback();
    }

    return {
      content: blob,
      representation: {
        size: blob.size,
        type: blob.type,
      },
    };
  }

  _createFallback() {
    // Return empty blob as fallback
    const emptyBlob = new Blob([], { type: 'audio/mp3' });
    return {
      content: emptyBlob,
      representation: {
        size: 0,
        type: 'audio/mp3',
      },
    };
  }
}

const blobAudioLoader = new BlobAudioLoader();
export { BlobAudioLoader, blobAudioLoader };
